import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import { selectCurrentUser } from 'store/user/selectors';

import { ANALYTICS_UUID, WEB_PAYMENT_PLATFORM } from 'constants/values';
import { WEB_USER_SOURCE } from 'constants/user';
import { DEFAULT_LANGUAGE, LANG_TO_LOCALE_MAP } from 'constants/localization';
import { CONTACT_US_LINK } from 'constants/links';

import { getDeviceInfo } from 'helpers/utils';

export const useGetCFLink = () => {
  const { os, browser } = getDeviceInfo();
  const { name, email, user_id, language, country, gender } = useSelector(selectCurrentUser);
  const payment_platform = user_id ? WEB_PAYMENT_PLATFORM : '';
  const locale = LANG_TO_LOCALE_MAP[language ?? DEFAULT_LANGUAGE];
  const uuid = localStorage.getItem(ANALYTICS_UUID) ?? '';

  return useMemo(() => {
    const queryParams = new URLSearchParams({
      locale,
      name: name ?? '',
      user_id: user_id ?? '',
      email: email ?? '',
      os_version: os,
      model: browser,
      payment_platform,
      source: WEB_USER_SOURCE,
      gender: gender ?? '',
      country: country ?? '',
      uuid: uuid ?? '',
      ab_test_name: '',
    });

    return `${CONTACT_US_LINK}?${queryParams.toString()}`;
  }, [uuid, name, email, user_id, locale, payment_platform, os, browser, gender, country]);
};
